import { Box, Tooltip } from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'

type ItemProps = {
  tooltipText: string
  label: string
}

const InfoTooltip = ({ tooltipText, label }: ItemProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '5px'
    }}
  >
    <span>{label}</span>
    <Tooltip title={tooltipText}>
      <InfoOutlinedIcon
        sx={{
          fontSize: 'inherit',
          marginBottom: '5px'
        }}
      />
    </Tooltip>
  </Box>
)

export default InfoTooltip
